import request from '@/api/request';

export function index(url, data) {
    return request({
        url: "/" + url,
        method: 'get',
        params: data
    });
}

export function create(url, data) {
    return request({
        url: "/" + url,
        method: 'post',
        data
    });
}

export function update(url, id, data) {
    return request({
        url: "/" + url + "/" + id,
        method: 'put',
        data
    });
}

export function show(url, id, data) {
    return request({
        url: "/" + url + "/" + id,
        method: 'get',
        params: data
    });
}

export function deleteQuery(url, id) {
    return request({
        url: "/" + url + "/" + id,
        method: 'delete'
    });
}

export function captcha(data) {
    return request({
        url: "captcha",
        method: 'get',
        params: data
    });
}